<template>
    <div class="well ovx-auto">
        <ul class="kpi-list list-inline acenter">
            <li v-for="kpi in kpis" class="kpi" :key="kpi.name">
                <div class="kpi-label" :tips="kpi.tips" >{{kpi.title}}</div>
                <div class="kpi-value">{{kpi.formatted}}</div>
            </li>
        </ul>

    </div>
</template>
<script>
export default {
    props : {
        /**
         * Each entry must have : 
         * + name : It's canonical name, use has key; Required
         * + title : Label above value; Required
         * + formatted : Value to display; Required
         * + tips : help at clic on indicator; Optional
         */
        kpis : {
            type: Array,
            required: true,
            validator: function (indicators) {
                let correct = true
                indicators.forEach((indicator) => {
                    correct = correct && indicator.hasOwnProperty('name') && indicator.name != ''
                    correct = correct && indicator.hasOwnProperty('title') && indicator.title != ''
                    correct = correct && indicator.hasOwnProperty('formatted') && indicator.formatted !== ''
                })

                return correct;
            }
        }
    }
}
</script>
